
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"28px","height":"29px","viewBox":"0 0 28 29","version":"1.1","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"id":"Symbols","stroke":"none","stroke-width":"1","fill":"none","fill-rule":"evenodd"}},[_c('g',{attrs:{"id":"Menu---Dark-BG","transform":"translate(-590.000000, -14.000000)","fill":"#FFFFFF","fill-rule":"nonzero"}},[_c('g',{attrs:{"id":"search"}},[_c('g',{attrs:{"transform":"translate(590.000000, 14.000000)"}},[_c('path',{attrs:{"d":"M27.5742784,26.4144051 L20.6717994,19.2359302 C22.446548,17.126321 23.4189432,14.4720008 23.4189432,11.7087385 C23.4189432,5.25264193 18.1659725,0 11.7094716,0 C5.25297079,0 0,5.25264193 0,11.7087385 C0,18.1648352 5.25297079,23.4174771 11.7094716,23.4174771 C14.1333323,23.4174771 16.4431528,22.6864445 18.4179806,21.2987045 L25.3728977,28.5316505 C25.663598,28.8335323 26.0545926,29 26.473588,29 C26.8701827,29 27.2464131,28.8488046 27.5320224,28.5739037 C28.1388785,27.989994 28.1582246,27.0217323 27.5742784,26.4144051 Z M11.7094716,3.05445353 C16.481845,3.05445353 20.3642985,6.93666398 20.3642985,11.7087385 C20.3642985,16.4808131 16.481845,20.3630236 11.7094716,20.3630236 C6.93709828,20.3630236 3.05464477,16.4808131 3.05464477,11.7087385 C3.05464477,6.93666398 6.93709828,3.05445353 11.7094716,3.05445353 Z","id":"Shape"}})])])])])])
          )
        }
      }
    